import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApproachService {
  constructor(private httpClient: HttpClient) {}

  getApproach(id): Observable<any> {
    if (id === 'direct-capture') id = 'co2-removal';
    return this.httpClient.get(`assets/approaches/${id}.json`);
  }
}
